/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Tab_ClassicInputs */

const en_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic`)
};

const ar_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلاسيك`)
};

const de_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klassisch`)
};

const es_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clásico`)
};

const fr_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classique`)
};

const it_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classico`)
};

const ja_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クラシック`)
};

const ko_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클래식`)
};

const pt_br_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clássico`)
};

const ru_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Классический`)
};

const th_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลาสสิก`)
};

const tr_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasik`)
};

const zh_cn_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`经典`)
};

const zh_tw_store_tab_classic = /** @type {(inputs: Store_Tab_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`經典`)
};

/**
* | output |
* | --- |
* | "Classic" |
*
* @param {Store_Tab_ClassicInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const store_tab_classic = /** @type {((inputs?: Store_Tab_ClassicInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Tab_ClassicInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_store_tab_classic(inputs)
	if (locale === "ar") return ar_store_tab_classic(inputs)
	if (locale === "de") return de_store_tab_classic(inputs)
	if (locale === "es") return es_store_tab_classic(inputs)
	if (locale === "fr") return fr_store_tab_classic(inputs)
	if (locale === "it") return it_store_tab_classic(inputs)
	if (locale === "ja") return ja_store_tab_classic(inputs)
	if (locale === "ko") return ko_store_tab_classic(inputs)
	if (locale === "pt_br") return pt_br_store_tab_classic(inputs)
	if (locale === "ru") return ru_store_tab_classic(inputs)
	if (locale === "th") return th_store_tab_classic(inputs)
	if (locale === "tr") return tr_store_tab_classic(inputs)
	if (locale === "zh_cn") return zh_cn_store_tab_classic(inputs)
	return zh_tw_store_tab_classic(inputs)
});